import { useAppContext } from "contexts/AppContextProvider";
import { formatNumber } from "services/numberService";

// Custom hook that automatically provides locale
export const useFormatNumber = () => {
  const { locale } = useAppContext();
  
  return (value, options) => formatNumber(value, options, locale || "de-DE");
};
